export default {
      id: "oeButton-usage",
      viewBox: "0 0 14 13",
      url: __webpack_public_path__ + "assets/webdesktop/web-desktop-sprite.svg#oeButton",
      toString: function () {
        return this.url;
      }
    }